<!--<div class="container-fluid">-->

<form id="self-information" [formGroup]="regForm" (ngSubmit)="step6Submitted(regForm)" novalidate>

  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large;">{{'Step6-Eligibility.TranslationSection.text1' | translate}}</label>
  </div><br><br>

  <div class="form-row">
    <div class="form-group col-lg-6 col-sm-6 col-md-6" >
      <label>{{'Step6-Eligibility.TranslationSection.text2' | translate}}
      </label>

    </div>
    <div class="form-group  col-lg-5 col-sm-5  col-md-5" >

      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="Legal" formControlName="Legal" value="Yes">
          <label class="form-check-label" for="yes">{{'Step6-Eligibility.TranslationSection.text3' | translate}}</label>
      </div>
      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="Legal2" formControlName="Legal" value="No">
          <label class="form-check-label" for="yes">{{'Step6-Eligibility.TranslationSection.text4' | translate}}</label>
      </div>   
      
      <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('Legal').invalid">
        ***required field***
    </div>
    </div>
</div>

<!-- remove according to the change requrement  Md-->
<!--
<div class="form-row">
  <div class="form-group  col-lg-6 col-sm-6  col-md-6" >
    <label>HAVE YOU EVER PLEAD GUILTY OR BEEN CONVICTED OF A CRIME?:
    </label>
  </div>
  <div class="form-group  col-lg-5 col-sm-5  col-md-5" >
    <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio"  id="Crime" formControlName="Crime" value="Yes" (click)="guiltyClick('Yes')">
        <label class="form-check-label" for="yes">Yes</label>
    </div>
    <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio"  id="Crime2" formControlName="Crime" value="No" (click)="guiltyClick('No')">
        <label class="form-check-label" for="yes">No</label>
    </div>  
    <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('Crime').invalid">
      ***required field***
    </div>
  </div>
</div>

<div class="form-row">
  <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
    <label>If you answered Yes, please explain in the space provided:
    </label>
  </div>
  <div class="form-group  col-lg-7 col-sm-7 col-md-7" >
    <div class="form-check form-check-inline">
      <textarea class="form-control"  id="Explain" for="Explain" formControlName="Explain" ></textarea>
    </div>
  </div>
</div>

<div class="form-row" style="height:50px;"></div>

<div class="form-row">
  <div class="form-group  col-lg-6 col-sm-6 col-md-6" >
    <label>HAVE YOU BEEN THE SUBJECT OF ANY ADVERSE ACTION(S) BY AND DULY AUTHORIZED SANCTIONS OR DISCIPLINARY AGENCY FOR EITHER CONDUCT BASED OR PERFORMANCE BASED ACTIONS?:
    </label>
  </div>
  <div class="form-group  col-lg-5 col-sm-5 col-md-5" >
    <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio"  id="Adverse" formControlName="Adverse" value="Yes" (click)="adverseClick('Yes')">
        <label class="form-check-label" for="yes">Yes</label>
    </div>
    <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio"  id="Adverse2" formControlName="Adverse" value="No" (click)="adverseClick('No')">
        <label class="form-check-label" for="yes">No</label>
    </div>     
    <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('Adverse').invalid">
      ***required field***
    </div>
  </div>
</div>

<div class="form-row">
  <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
    <label>If you answered Yes, please explain in the space provided:
    </label>
  </div>
  <div class="form-group  col-lg-7 col-sm-7 col-md-7" >

    <div class="form-check form-check-inline">
      <textarea class="form-control"  id="ExplainAdverse" for="ExplainAdverse" formControlName="ExplainAdverse" ></textarea>
    </div>
  </div>
</div>
-->

<br/>
<button type="button" (click) = "decreasePage()" class="btn btn-create" matStepperPrevious>
  <i className="ace-icon fa fa-arrow-left"></i>{{'Step6-Eligibility.TranslationSection.text5' | translate}}</button> &nbsp;
<button type="submit"  class="btn btn-primary" >{{'Step6-Eligibility.TranslationSection.text6' | translate}} &nbsp; 
  <i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>
<div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true">
</div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> {{'Step6-Eligibility.TranslationSection.text7' | translate}}</i>
    
</form>

<!--</div>-->